/* Toko Milobi redesign 2026: quick add-to-cart for tmx product cards (works for cards loaded later too) */
(function(){
  var live;
  function announce(msg){
    if(!live){live=document.createElement('div');live.className='tmx-visually-hidden';live.setAttribute('aria-live','polite');document.body.appendChild(live);}
    live.textContent='';setTimeout(function(){live.textContent=msg},50);
  }
  document.addEventListener('submit',function(e){
    var form=e.target.closest&&e.target.closest('form.tmx-card__foot');
    if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('button[type=submit]');
    var idInput=form.querySelector('input[name=id]');
    if(!btn||!idInput||btn.disabled)return;
    var label=btn.innerHTML;
    btn.disabled=true;btn.setAttribute('aria-busy','true');
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(idInput.value),quantity:1}]})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
      .then(function(){
        try{var card=form.closest('[data-tmx-product]');if(card)document.dispatchEvent(new CustomEvent('tm:quick-add',{detail:{variant_id:Number(idInput.value),card:card}}));}catch(err){}
        btn.innerHTML='&#10003;';btn.classList.add('is-added');
        announce('Toegevoegd aan je winkelmandje');
        if(window.theme&&typeof theme.updateCartSummaries==='function'){theme.updateCartSummaries(false);}
        setTimeout(function(){btn.innerHTML=label;btn.classList.remove('is-added');btn.disabled=false;btn.removeAttribute('aria-busy');},1600);
      })
      .catch(function(){btn.disabled=false;btn.removeAttribute('aria-busy');form.submit();});
  });
})();
